import { useState } from 'react';

import useTranslations from '@/i18n/useTranslations';
import GoBackButton from '@/shared-components/buttons/components/GoBackButton';

import '../profile/styles.css';

export default function ProfileArtistHelpPaymentCommissionsPage() {
  const t = useTranslations('artist_help.payment_commissions');
  const [openSections, setOpenSections] = useState({
    commissions: false,
    payments: false,
  });

  function toggleSection(sectionKey) {
    setOpenSections((previous) => ({
      ...previous,
      [sectionKey]: !previous[sectionKey],
    }));
  }

  return (
    <section className="artist-help-category">
      <header className="artist-help-category__header">
        <GoBackButton alternativeRoute="/profile/artist-help" />
        <h1>{t('title')}</h1>
      </header>

      <div className="artist-help-category__body">
        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('commissions')}
            aria-expanded={openSections.commissions}
          >
            <h2>{t('sections.commissions.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.commissions ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.commissions && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.commissions.intro_p1')}</p>

              <div className="artist-help-category__stack">
                <h3>{t('sections.commissions.in_platform_title')}</h3>
                <p>{t('sections.commissions.in_platform_p1')}</p>
                <ul>
                  <li>{t('sections.commissions.in_platform_list_1')}</li>
                  <li>{t('sections.commissions.in_platform_list_2')}</li>
                </ul>
                <p>{t('sections.commissions.in_platform_p2')}</p>
              </div>

              <div className="artist-help-category__stack">
                <h3>{t('sections.commissions.in_store_title')}</h3>
                <p>{t('sections.commissions.in_store_p1')}</p>
                <ul>
                  <li>{t('sections.commissions.in_store_list_1')}</li>
                  <li>{t('sections.commissions.in_store_list_2')}</li>
                </ul>
              </div>

              <div className="artist-help-category__stack">
                <h3>{t('sections.commissions.support_subscriptions_title')}</h3>
                <p>{t('sections.commissions.support_subscriptions_p1')}</p>
                <ul>
                  <li>{t('sections.commissions.support_subscriptions_list_1')}</li>
                  <li>{t('sections.commissions.support_subscriptions_list_2')}</li>
                </ul>
              </div>

              <div className="artist-help-category__stack">
                <h3>{t('sections.commissions.limited_editions_title')}</h3>
                <p>{t('sections.commissions.limited_editions_p1')}</p>
                <ul>
                  <li>{t('sections.commissions.limited_editions_list_1')}</li>
                  <li>{t('sections.commissions.limited_editions_list_2')}</li>
                  <li>{t('sections.commissions.limited_editions_list_3')}</li>
                </ul>
              </div>

              <div className="artist-help-category__stack">
                <h3>{t('sections.commissions.suarte_plus_title')}</h3>
                <p>{t('sections.commissions.suarte_plus_p1')}</p>
              </div>

              <div className="artist-help-category__note">
                <h3>{t('sections.commissions.important_title')}</h3>
                <p>{t('sections.commissions.important_p1')}</p>
              </div>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('payments')}
            aria-expanded={openSections.payments}
          >
            <h2>{t('sections.payments.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.payments ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.payments && (
            <div className="artist-help-category__accordion-content">
              <div className="artist-help-category__stack">
                <h3>{t('sections.payments.originals_le_title')}</h3>
                <p>{t('sections.payments.originals_le_p1')}</p>
                <p>{t('sections.payments.originals_le_p2')}</p>
              </div>

              <div className="artist-help-category__stack">
                <h3>{t('sections.payments.support_subscriptions_title')}</h3>
                <p>{t('sections.payments.support_subscriptions_p1')}</p>
              </div>

              <div className="artist-help-category__stack">
                <h3>{t('sections.payments.payout_setup_title')}</h3>
                <ul>
                  <li>{t('sections.payments.payout_setup_list_1')}</li>
                  <li>{t('sections.payments.payout_setup_list_2')}</li>
                  <li>{t('sections.payments.payout_setup_list_3')}</li>
                </ul>
              </div>

              <div className="artist-help-category__note">
                <h3>{t('sections.payments.taxes_title')}</h3>
                <p>{t('sections.payments.taxes_p1')}</p>
              </div>
            </div>
          )}
        </section>
      </div>
    </section>
  );
}
